import { Link } from "react-router-dom";
import { lastWorkspace } from "../lib/workspaces";
import { useAuth } from "../lib/auth";

export function Welcome() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
        <div className="w-full max-w-md text-center">
          <div className="bg-white rounded-xl shadow-sm border border-stone-200 p-8">
            <p className="text-sm text-stone-500">Session expired.</p>
            <Link to="/login" className="text-sm text-brand-500 hover:underline font-medium mt-2 inline-block">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <div className="flex items-center gap-2">
            <img src="/singvms-seal.svg" alt="SingVMS" className="w-9 h-9" />
            <span className="text-xl font-bold text-stone-900 font-display">SingVMS</span>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-stone-200 p-8 text-center">
          <div className="text-4xl mb-4">&#127881;</div>
          <h1 className="text-2xl font-semibold text-stone-900 mb-2 font-display">Welcome to SingVMS</h1>
          <p className="text-sm text-stone-500 mb-6">
            We're verifying your ACRA registration and business details. We'll call you shortly to complete setup — most accounts are activated within one business day.
          </p>

          <div className="space-y-3">
            <Link
              to={lastWorkspace() ? `/w/${lastWorkspace()!.slug}/checkins` : "/"}
              className="block w-full py-2.5 bg-brand-500 text-white text-sm font-medium rounded-lg hover:bg-brand-700 transition-colors text-center"
            >
              Continue
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
